import { createPaginator } from "@smithy/core";
import { DescribeProjectVersionsCommand, } from "../commands/DescribeProjectVersionsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateDescribeProjectVersions = createPaginator(RekognitionClient, DescribeProjectVersionsCommand, "NextToken", "NextToken", "MaxResults");
